import { Typography } from '@mui/material';
import { Theme, useTheme } from '@mui/material/styles';

import { useAppSelector } from '@/hooks/redux';
import { useTranslate } from '@/hooks/useTranslate';

import { selectIsMinorAccount } from '@/redux/user-data/selectors';

import { getDataTestId } from '@/utils/browser';

import AccountTypeForm from '../components/AccountTypeForm';

import { AccountTypeContainer, StyledScreen } from './AccountType.styled';

export default function AccountTypeScreen() {
  const { t } = useTranslate();
  const isMinorAccount = useAppSelector(selectIsMinorAccount);
  const theme = useTheme();

  return (
    <StyledScreen
      header={{
        bgColor: (theme: Theme) => theme.palette.neutral[100],
        leftSlot: <div />,
      }}
      center
    >
      <AccountTypeContainer>
        <Typography
          variant="h3"
          textAlign="center"
          {...getDataTestId('account-type-title')}
        >
          {isMinorAccount
            ? t('accountType.joint.title')
            : t('accountType.title')}
        </Typography>
        <Typography
          variant="body2"
          color={theme.palette.neutral[800]}
          textAlign="center"
          mb={3}
          px={3}
          {...getDataTestId('account-type-body')}
        >
          {isMinorAccount ? t('accountType.joint.body') : t('accountType.body')}
        </Typography>
        <AccountTypeForm />
      </AccountTypeContainer>
    </StyledScreen>
  );
}
